import { Link } from "react-router-dom";

export function Logo({ className = "", onClick, onDark = false, showWordmark = true }) {
  return (
    <Link
      to="/"
      onClick={onClick}
      className={`flex items-center gap-2 ${className}`}
      data-testid="brand-logo"
    >
      <img
        src="/brand/app_icon.png"
        alt="My Within"
        className="h-9 w-9 shrink-0 rounded-xl object-cover"
      />
      {showWordmark && (
        <span className={`font-display text-xl font-semibold tracking-tight ${onDark ? "text-oat" : "text-foreground"}`}>
          My Within
        </span>
      )}
    </Link>
  );
}
